import * as actionTypes from "../types";

const initialState = {
    addedBook: false,
    selectedBook: {},
    books: [], 
    bookEmpty: false,
    deletedBook: false, 
    updatedBook: false,
    bookmarks: [],
    bookmarkEmpty: false,
    reservedBooks: [], 
    reserveEmpty: false,
    favorites: [], 
    favoritesEmpty: false
}

export default function bookReducer(state=initialState, action){
    switch(action.type){
        case actionTypes.GET_BOOK: {
            return {
                ...state,
                books: action.payload.books,
                bookEmpty: action.payload.bookEmpty
            };
        }
        case actionTypes.GET_FAVORITES: {
            return {
                ...state,
                favorites: action.payload.favorites,
                favoritesEmpty: action.payload.favoritesEmpty
            };
        }
        case actionTypes.GET_BOOKMARKS: {
            return {
                ...state,
                bookmarks: action.payload.bookmarks,
                bookmarkEmpty: action.payload.bookmarkEmpty
            };
        }
        case actionTypes.GET_RESERVED: {
            return {
                ...state,
                reservedBooks: action.payload.reservedBooks,
                reserveEmpty: action.payload.reserveEmpty
            };
        }
        case actionTypes.SELECT_BOOK: {
            return {
                ...state,
                selectedBook: action.payload,
            };
        }
        default: {
            return{
                ...state
            };
        }
    }
}


